// Deterministic initials avatar (no user-directory in the frozen Connect contract,
// so we render from the identifier we have). See walkthrough Blockers.
import React from "react";

const COLORS = ["#033F99", "#7c3aed", "#0891b2", "#059669", "#d97706", "#db2777", "#4f46e5", "#0d9488"];

function hash(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

function getInitials(name) {
  const clean = (name || "?").toString().trim();
  if (!clean || clean === "?") return "?";
  const parts = clean.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }
  return clean.charAt(0).toUpperCase();
}

export default function Avatar({ name, size = 36, className = "" }) {
  const label = (name || "?").toString().trim() || "?";
  const initials = getInitials(label);
  const color = COLORS[hash(label) % COLORS.length];
  return (
    <div
      className={`flex shrink-0 items-center justify-center rounded-full font-semibold text-white select-none ${className}`}
      style={{ width: size, height: size, backgroundColor: color, fontSize: size * (initials.length > 1 ? 0.38 : 0.42) }}
      title={label}
    >
      {initials}
    </div>
  );
}
